import React from "react";
import { View, Text, StyleSheet } from "../platformComponents";
import { IS_WEB, tranformPx } from "@adgm/libs";

interface ITermsAndMetricsItem {
  title: string;
  subtitle: string;
}

interface ITermsAndMetricsProps {
  title: string;
  detail: ITermsAndMetricsItem[];
}

export const TermsAndMetrics: React.FC<ITermsAndMetricsProps> = ({ title, detail }) => (
  <View style={styles.container}>
    <Text style={styles.title}>{title}</Text>
    <View style={styles.table}>
      {detail?.map((item, idx) => (
        <View style={[styles.row, idx === detail.length - 1 && { marginBottom: 0 }]} key={idx}>
          <Text style={styles.cellTitle}>{item.title}</Text>
          <Text style={styles.cellSubtitle}>{item.subtitle}</Text>
        </View>
      ))}
    </View>
  </View>
);

const styles = StyleSheet.create({
  container: {
    width: "100%",
    ...(IS_WEB && {
      height: "100%",
      display: "flex",
      flexDirection: "column",
    }),
  },
  title: {
    fontWeight: "700",
    marginBottom: tranformPx(16),
    ...(IS_WEB
      ? {
          fontSize: 22,
          color: "rgba(255, 255, 255, 0.8)",
        }
      : {
          fontSize: tranformPx(18),
          color: "#fff",
        }),
  },
  table: {
    flex: 1,
    borderRadius: 16,
    borderWidth: 1,
    ...(IS_WEB
      ? {
          padding: 32,
          borderColor: "#3F434F",
        }
      : {
          padding: 16,
          borderColor: "#303030",
        }),
  },
  row: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: tranformPx(16),
    gap: tranformPx(4),
  },
  cellTitle: {
    flex: 1,
    color: "rgba(255, 255, 255, 0.7)",
    ...(!IS_WEB && { fontSize: tranformPx(14) }),
  },
  cellSubtitle: {
    flex: 1,
    color: "#fff",
    textAlign: "right",
    fontWeight: "500",
    ...(!IS_WEB && { fontSize: tranformPx(14) }),
  },
});
